import { render } from "./Statistical.vue?vue&type=template&id=ecb1f174&scoped=true"
import script from "./Statistical.vue?vue&type=script&lang=js"
export * from "./Statistical.vue?vue&type=script&lang=js"

import "./Statistical.vue?vue&type=style&index=0&id=ecb1f174&lang=scss&scoped=true"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb1f174"]])

export default __exports__